import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TextboxWithUnitsComponent } from './textbox-with-units.component'
import { InputTextModule } from 'primeng/inputtext'
import { FormsModule } from '@angular/forms'

@NgModule({
  declarations: [TextboxWithUnitsComponent],
  imports: [CommonModule, InputTextModule, FormsModule],
  exports: [TextboxWithUnitsComponent],
})
export class TextboxWithUnitsModule {}
